<template>
    <div class="flex flex-col gap-2">
        <UCheckbox
            v-for="o in options"
            :key="o.value"
            :model-value="current.includes(o.value)"
            @update:model-value="toggle(o.value, $event)"
        >
            <template #label>
                <span class="flex items-center gap-1.5">
                    <span :class="[o.dot, 'inline-block size-1.5 flex-shrink-0 rounded-full']" aria-hidden="true" />
                    {{ o.name }}
                </span>
            </template>
        </UCheckbox>
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const options = [
    { name: 'Active', value: 'active', dot: 'bg-blue-500' },
    { name: 'Expired', value: 'expired', dot: 'bg-red-500' },
    { name: 'Unsubscribed', value: 'unsubscribed', dot: 'bg-gray-500' },
]

const current = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

function toggle(value: string, on: boolean) {
    const next = on ? [...current.value, value] : current.value.filter(v => v !== value)
    emit('update:filter', { ...props.filter, value: next.length ? next : undefined, selected: next.length ? next : undefined })
}
</script>
